export default __webpack_public_path__ + "static/media/6.f94003d5.png";